import React, { Component } from "react";
import axios from "axios";
import navbar from "../../helpers/navbar"
import HomeBody from "../components/HomeBody";
import WarrantBody from "../components/WarrantBody";
import WarrantNoBody from "../components/WarrantNoBody";
import NotificationPage from "../components/NotificationPage";

class Home extends Component {
    constructor() {
        super();
        this.state = {
            isAdmin: false,
            activeContentBody: "homeBody",
            warrants: {},
            electronic: {},
            consent: {},
            information: {},
            traffic: {},
            icac: {},
            firearm: {},
            contacts:{}
        };
        this.switchActive = this.switchActive.bind(this);
    }
    componentDidMount() {
        debugger;
        //One container for each unique spLibrary
        let containers = [{}, {}, {}, {}, {}, {}, {}, {}];
        new Promise((resolve, reject) => {
            if (!this.props.authorized) {
                resolve();
            } else {
                axios.post("/isAdmin").then(results => {
                    if (results.data.isAdmin) {
                        this.setState({ isAdmin: true });
                    }
                    resolve();
                });
            }
        }).then(() => {
            return axios.post("/getSharepoint");
        }).then(response => {
            debugger;
            //const spLibraries = ["Search Warrant Templates", "Electronic Surveillance Templates", "Consent", "Warrant Resources", "Criminal Traffic Warrants", "ICAC Warrant Templates","Regional DV Firearms Enforcement Unit Forms"];
            const spLibraries = ["Search Warrant Templates", "Electronic Surveillance Templates", "Consent", "Warrant Resources", "Criminal Traffic Warrants", "ICAC Warrant Templates","Regional DV Firearms Enforcement Unit Forms","Contacts"];
            for (let i = 0; i < spLibraries.length; i++) {
             
                let libraryData = response.data[spLibraries[i]];
                for (let file in libraryData) {
                    if (containers[i][libraryData[file].Subfolder]) {
                        containers[i][libraryData[file].Subfolder].push({ Name: libraryData[file].Name, Description: libraryData[file].Description, Subfolder: libraryData[file].Subfolder });
                    } else {
                        containers[i][libraryData[file].Subfolder] = [{ Name: libraryData[file].Name, Description: libraryData[file].Description, Subfolder: libraryData[file].Subfolder }];
                    }
                }
            };
            this.setState({ warrants: containers[0], electronic: containers[1], consent: containers[2], information: containers[3], traffic: containers[4], icac: containers[5] ,firearm: containers[6],contacts:containers[7]});
        });
    }
    componentDidUpdate(prevProps) {
        debugger;
        if (prevProps.authorized !== this.props.authorized) {
            axios.post("/isAdmin").then(results => {
                if (results.data.isAdmin) {
                    this.setState({ isAdmin: true });
                }
            });
        }
    }
    switchActive(e) {
       debugger;
        let targetID = e.currentTarget.id;
        let target = document.getElementById(targetID);
        navbar("contentTab", target);
        this.setState({ activeContentBody: targetID });
    }
    render() {
        let activeContentBody;
        let warrantNumberButton;
        let warrantNumberButton2;
        let desclaimerpage;
        //To do: replace with user managed banner content
        if (this.props.authorized) {
            warrantNumberButton = (
                <button type="button" id="warrantNoBody" className="contentTab" onClick={this.switchActive}>
                    Get a Felony Search Warrant Number
                </button>
                 
            )
            warrantNumberButton2=(<button type="button" id="contacts" className="contentTab" onClick={this.switchActive}>
                Contacts
        </button> )
         desclaimerpage=""
        
        }
        else{
            desclaimerpage=(< NotificationPage />)
        }
        switch (this.state.activeContentBody) {
            case "infoBody":
                activeContentBody = <WarrantBody warrants={this.state.information} page={this.state.activeContentBody} banner={-1} defaultAll={false} />;
                break;
            case "icacBody":
                activeContentBody = <WarrantBody warrants={this.state.icac} page={this.state.activeContentBody} banner={"icac"} defaultAll={false} />;
                break;
            case "trafficBody":
                activeContentBody = <WarrantBody warrants={this.state.traffic} page={this.state.activeContentBody} banner={"traffic"} defaultAll={false} />;
                break;
            case "consentBody":
                activeContentBody = <WarrantBody warrants={this.state.consent} page={this.state.activeContentBody} banner={-1} defaultAll={false} />;
                break;
            case "electricBody":
                activeContentBody = <WarrantBody warrants={this.state.electronic} page={this.state.activeContentBody} banner={"electric"} defaultAll={false} />;
                break;
            case "warrantBody":
                activeContentBody = <WarrantBody warrants={this.state.warrants} page={this.state.activeContentBody} banner={"warrant"} defaultAll={false} />;
                break;
            case "warrantNoBody":
                activeContentBody = <WarrantNoBody isAdmin={this.state.isAdmin} page={this.state.activeContentBody} />;
                break;
            case "firearmBody":
                activeContentBody = <WarrantBody warrants={this.state.firearm} page={this.state.activeContentBody} banner={-1} defaultAll={false}  />;
                break;
            case "contacts":
                activeContentBody = <WarrantBody warrants={this.state.contacts} page={this.state.activeContentBody} banner={-1} defaultAll={false}  />;
                break;    
            case "homeBody":
            default:
                activeContentBody = <HomeBody />
                break;

                
        }
        return (
            <div>
                <div className="contentTabs">
                    <div className="contentTabs__container">
                        <button type="button" id="homeBody" className="contentTab selected" onClick={this.switchActive}>
                            &nbsp;&nbsp;Home&nbsp;&nbsp;
                        </button>
                        {warrantNumberButton}
                        <button type="button" id="warrantBody" className="contentTab" onClick={this.switchActive}>
                            Search Warrant Templates
                        </button>
                        <button type="button" id="electricBody" className="contentTab" onClick={this.switchActive}>
                            Electronic Surveillance Templates
                        </button>
                        <button type="button" id="consentBody" className="contentTab" onClick={this.switchActive}>
                            Consent to Search Forms and Preservation Letters
                        </button>
                        <button type="button" id="trafficBody" className="contentTab" onClick={this.switchActive}>
                            Criminal Traffic Warrant Templates
                        </button>
                        <button type="button" id="icacBody" className="contentTab" onClick={this.switchActive}>
                            ICAC Warrant Templates
                        </button>
                       
                        <button type="button" id="infoBody" className="contentTab" onClick={this.switchActive}>
                            Resources
                        </button>
                        
                        <button type="button" id="firearmBody" className="contentTab" onClick={this.switchActive}>
                        Extreme Risk Protection Orders
                        </button>
                        {/* <button type="button" id="contacts" className="contentTab" onClick={this.switchActive}>
                        Contacts
                        </button> */}
                        {warrantNumberButton2}
                        {desclaimerpage}
                        {/* < NotificationPage /> */}
                    </div>
                </div>
                <div className="body">
                    <div className="body__container">
                        <div className="body__content">
                            {activeContentBody}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Home;